import React, { ReactNode } from 'react';
import classnames from 'classnames';
import AddAssociationButton from 'v2/common/DRM/AddAssociationButton/AddAssociationButton';
import NoAssociationsPlaceholder from 'v2/common/DRM/NoAssociationsPlaceholder/NoAssociationsPlaceholder';
import styles from 'v2/common/DRM/AssociationTab/associationTab.module.scss';

interface AssociationTabProps {
  groups: { name: string; items: ReactNode[] }[];
  buttonLabel: string;
  onButtonClick: () => void;
  children?: ReactNode;
  image?: string;
  showButton?: boolean;
}

const AssociationTabList = ({
  groups,
  buttonLabel,
  onButtonClick,
  children,
  image,
  showButton = true,
}: AssociationTabProps) => {
  return (
    <>
      <div
        className={classnames(
          styles.controlPanel,
          groups?.length === 0 && styles.noDataControlPanel
        )}
      >
        <div>
          {showButton && groups.length > 0 && (
            <AddAssociationButton onClick={onButtonClick} label={buttonLabel} />
          )}
        </div>
      </div>
      <div>
        {groups.length > 0 ? (
          <>
            {groups.map((group, ix) => {
              if (group.items.length === 0) {
                return null;
              }
              return (
                <div
                  className={classnames({
                    [styles.listContainer]: true,
                    [styles.bottomList]: ix === groups.length - 1,
                  })}
                  key={group.name}
                  data-cy={`associationtab:${group.name}`}
                >
                  <h3 className={classnames(styles.listTitle)}>{group.name}</h3>
                  {group.items}
                </div>
              );
            })}
          </>
        ) : (
          <NoAssociationsPlaceholder
            onButtonClick={onButtonClick}
            buttonLabel={buttonLabel}
            image={image}
          />
        )}
      </div>
      {children}
    </>
  );
};

export default AssociationTabList;
